// @flow

const getCityError = (city: string): string | null => {
  if (city.length === 0) {
    return "Woonplaats is niet ingevuld.";
  }
};

export default getCityError;
